import type { IndexProductVariant } from '@/domains/variants/types/models/IndexProductVariant.types.ts'

type VariantWithOptions = Partial<Pick<IndexProductVariant, 'variant_type_options'>>

export const useProductVariantHelper = () => {
  const getVariantOptions = (productVariant: VariantWithOptions, separator = '/'): string => {
    if (!productVariant.variant_type_options || productVariant.variant_type_options.length === 0) {
      return ''
    }
    return productVariant.variant_type_options.map(item => item.value).join(separator)
  }

  /** Falls back to 'Auto Assigned'. Where the product's title is the better stand-in, use `getVariantName`. */
  const getVariantDisplayName = (productVariant: VariantWithOptions, fallback = true): string => {
    const options = getVariantOptions(productVariant)
    if (options) return options
    return fallback ? `Auto Assigned` : ''
  }

  /** A variant is named by its options joined with ' / '; a default variant has none, so its product's title stands in. */
  const getVariantName = (productVariant: VariantWithOptions, productTitle: string): string =>
    getVariantOptions(productVariant, ' / ') || productTitle

  const summarizeTitle = (productVariant: IndexProductVariant) => {
    const productTitle = productVariant.product.title
    const variantOptions = getVariantOptions(productVariant, ' / ')

    if (!variantOptions) {
      return productTitle
    }

    return `${productTitle} (${variantOptions})`
  }

  const hasFees = (productVariant: IndexProductVariant): boolean => !!productVariant.fees?.length

  return {
    getVariantOptions,
    getVariantDisplayName,
    getVariantName,
    summarizeTitle,
    hasFees
  }
}
